import __request__ from "routing/request";
export function listAssets(sort = "title", page = 1, per_page = 15, query, filters, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/assets/sources", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/assets/sources", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkTestConnections(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/assets/sources/bulk/test", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listMs356DeploymentTypes(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/assets/sources/ms365-deployment-types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testNewConnection(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/assets/sources/test", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(sourceId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(sourceId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSource(sourceId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/assets/sources/${sourceId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
